import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {Apollo} from 'apollo-angular';
import {NotificationService} from 'src/app/services/notification.service';
import {ResponseCodeService} from 'src/app/services/response-code.service';
import {AppState} from 'src/app/store/reducers';
import {map, switchMap} from 'rxjs';

import * as fromGraphql from './districts.graphql'
import * as fromActions from './districts.actions'

@Injectable()
export class DistrictsEffects {
  getAllDistricts$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getAllDistricts),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_ALL_DISTRICTS,
        fetchPolicy: 'network-only',
        variables: {
          regionalUniqueId: action.regionalUniqueId
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching services'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadDistrictss({ districtss: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });

  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService) {}
}
